import './status-dot.scss'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

type Props = Overwrite<
  CommonProps<'span'>,
  {
    status?: 'default' | 'warning' | 'error' | 'success'
  }
>

const StatusDot = ({className, status = 'default', ...props}: Props) => (
  <span {...props} className={cn('StatusDot', {[`status-${status}`]: true}, className)} />
)

export default StatusDot
